<template>
<div>
    <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
    <b-table-simple v-else hover responsive>
        <b-thead>
            <b-th>{{$t('account.zone.no')}}</b-th>
            <b-th>{{$t('account.zone.name')}}</b-th>
            <b-th>{{$t('account.zone.type')}}</b-th>
            <b-th>{{$t('account.zone.serviceState')}}</b-th>
            <b-th>{{$t('account.zone.serviceTime')}}</b-th>
            <b-th>{{$t('account.zone.operations')}}</b-th>
        </b-thead>
        <b-tbody>
            <b-tr v-for="zone in zones" :key="zone.id">
                <b-th> {{zone.zone_no}} </b-th>
                <b-th> {{zone.name}} </b-th>
                <b-td> {{zone.zone_type.name}} </b-td>
                <b-td> 
                    <b-icon v-if="zone.is_service" icon="check" variant="success" scale="1.25" shift-v="1.25" aria-hidden="true" :title="$t('account.inService')"></b-icon>
                    <b-icon v-else icon="x" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true" :title="$t('account.notInService')"></b-icon>
                </b-td>
                <b-td> {{zone.service_time}} </b-td>
                <b-td> 
                    <b-icon icon="pencil-square" variant="primary" scale="1.25" shift-v="1.25" aria-hidden="true" :title="$t('general.edit')" @click="openModal('edit', zone)" ></b-icon>
                    <b-icon icon="trash" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true" :title="$t('general.delete')" @click="openModal('delete', zone)" ></b-icon>
                </b-td>
            </b-tr>
        </b-tbody>
    </b-table-simple>
    </div>
</template>

<script>
    export default {
        name: "ZoneForm",
        props: {
            modalEvent: { type: Function },
            modalType: { type: Function }
        },
        methods:{
            openModal: async function(name, data){
                await this.modalType([true, false], 'Zone', 1)
                await this.modalEvent(true, name, data)
            }
        },
        computed: {
            accountId(){
                return this.$store.getters.accountId
            },
            zones(){
                return this.$store.getters.getAccountZones
            },
            loading(){
                return this.$store.getters.getAccountLoading
            }
        }
    }
</script>

<style lang="css" scoped> 
    @import "../styles/zone.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Account/components/ZoneForm.vue